// extracted by mini-css-extract-plugin
export default {"toast":"ToastNotification-module__toast___5Tkaf","checkmark":"ToastNotification-module__checkmark___QdQ6T"};